// ============================================================================
// SAGESSE SPIRITUELLE - La connaissance qui vivifie l'esprit
// ============================================================================

export const spiritualWisdom = {
  // Principe fondamental
  coreTeaching: {
    principle: "La connaissance permet à l'esprit de se vivifier",
    foundationalTruth: "L'étude des Écritures n'est pas seulement intellectuelle mais spirituelle - elle nourrit, transforme et vivifie notre être intérieur"
  },

  // Versets sur la connaissance spirituelle
  knowledgeVerses: [
    {
      reference: "Osée 4:6",
      text: "Mon peuple est détruit, parce qu'il lui manque la connaissance",
      application: "L'ignorance spirituelle mène à la destruction, la connaissance divine à la vie"
    },
    {
      reference: "Jean 17:3", 
      text: "Or, la vie éternelle, c'est qu'ils te connaissent, toi le seul vrai Dieu, et celui que tu as envoyé, Jésus-Christ",
      application: "Connaître Dieu personnellement = essence même de la vie éternelle"
    },
    {
      reference: "Jean 8:32",
      text: "Vous connaîtrez la vérité, et la vérité vous affranchira",
      application: "La vérité divine libère l'âme de tous les esclavages spirituels"
    },
    {
      reference: "Proverbes 1:7",
      text: "La crainte de l'Éternel est le commencement de la science",
      application: "Toute vraie connaissance commence par le respect révérencieux de Dieu"
    },
    {
      reference: "2 Pierre 3:18",
      text: "Croissez dans la grâce et dans la connaissance de notre Seigneur et Sauveur Jésus-Christ",
      application: "La croissance spirituelle passe par la connaissance progressive du Christ"
    },
    {
      reference: "Éphésiens 1:17",
      text: "Que le Dieu de notre Seigneur Jésus-Christ vous donne un esprit de sagesse et de révélation, dans sa connaissance",
      application: "L'Esprit Saint révèle la connaissance divine qui transforme nos cœurs"
    },
    {
      reference: "Colossiens 1:9-10",
      text: "Afin que vous soyez remplis de la connaissance de sa volonté, en toute sagesse et intelligence spirituelle, pour marcher d'une manière digne du Seigneur",
      application: "La connaissance divine guide notre marche quotidienne"
    },
    {
      reference: "1 Corinthiens 8:1",
      text: "La connaissance enfle, mais l'amour édifie",
      application: "La vraie connaissance spirituelle est toujours accompagnée d'amour"
    }
  ],

  // Bénéfices de la connaissance spirituelle
  benefits: [
    {
      benefit: "Vivification de l'esprit",
      description: "L'esprit humain s'épanouit et trouve sa véritable vie dans la connaissance de Dieu",
      verse: "L'esprit de l'homme est une lampe de l'Éternel (Proverbes 20:27)"
    },
    {
      benefit: "Transformation du cœur", 
      description: "La connaissance divine transforme nos pensées, désirs et motivations",
      verse: "Soyez transformés par le renouvellement de l'intelligence (Romains 12:2)"
    },
    {
      benefit: "Libération spirituelle",
      description: "La vérité divine brise les chaînes de l'ignorance et du péché",
      verse: "Si le Fils vous affranchit, vous serez réellement libres (Jean 8:36)"
    },
    {
      benefit: "Paix intérieure",
      description: "Connaître Dieu apporte une paix qui surpasse toute intelligence",
      verse: "Tu conserves dans la paix celui dont les pensées s'arrêtent sur toi (Ésaïe 26:3)"
    },
    {
      benefit: "Sagesse pour la vie",
      description: "La connaissance divine éclaire nos décisions et notre conduite",
      verse: "Ta parole est une lampe à mes pieds et une lumière sur mon sentier (Psaume 119:105)"
    }
  ],

  // Moyens de croître dans la connaissance
  growthMethods: [
    {
      method: "Étude des Écritures",
      description: "Lecture méditative et approfondie de la Parole de Dieu",
      principle: "Chaque verset étudié enrichit l'âme et fortifie la foi"
    },
    {
      method: "Prière contemplative", 
      description: "Communication intime avec Dieu qui révèle ses mystères",
      principle: "Dans la prière, l'Esprit nous enseigne toutes choses"
    },
    {
      method: "Méditation biblique",
      description: "Ruminer les vérités divines pour qu'elles pénètrent profondément",
      principle: "La méditation fait germer la Parole dans notre cœur"
    },
    {
      method: "Communion fraternelle",
      description: "Partager avec d'autres croyants enrichit notre compréhension",
      principle: "Le fer aiguise le fer, et l'homme aiguise l'homme"
    },
    {
      method: "Obéissance pratique",
      description: "Mettre en pratique ce que nous apprenons approfondit notre connaissance",
      principle: "Si quelqu'un veut faire sa volonté, il connaîtra si ma doctrine est de Dieu"
    }
  ],

  // Messages pour chaque chapitre
  chapterWisdom: {
    1: "Dans la Genèse, découvrir les origines vivifie notre compréhension du plan divin",
    2: "L'Exode nous enseigne comment la connaissance de Dieu libère et transforme",
    3: "Connaître Jésus-Christ, c'est accéder à la source même de la vie éternelle", 
    4: "La crucifixion et résurrection révèlent l'amour ultime qui régénère l'esprit",
    5: "L'Église primitive montre comment la connaissance divine se répand et vivifie",
    6: "Les missions de Paul illustrent la puissance de la vérité qui transforme les nations",
    7: "Les épîtres et l'Apocalypse couronnent notre connaissance de l'espérance éternelle"
  },

  // Citation finale
  conclusion: {
    text: "La connaissance des Écritures n'est pas un simple exercice intellectuel, mais une nourriture spirituelle qui vivifie, transforme et édifie l'âme humaine pour l'éternité.",
    blessing: "Que chaque vérité découverte dans ce jeu fortifie votre foi et vivifie votre esprit !"
  }
};